export default __webpack_public_path__ + "static/media/UMCA.5963cf3e.png";